import React from 'react'
import PropTypes from 'prop-types'
import cssModules from 'react-css-modules'
import styles from './create_publish.less'
import { getI18n } from 'client/i18n'
import StandardError from 'components/common/standard_error'
import CrossFadeTransition from 'components/common/transitions/cross_fade'
import { UNDER_REVIEW_ERROR } from 'shared/shared_consts'
import { NEW_CAMPAIGN_ID } from 'redux/modules/campaign'
import { Link } from 'react-router'
import { sendEnsightenEvent } from 'lib/ensighten_analytics'

const i18n = getI18n('components/pages/create/pool_publish')

class PoolPublish extends React.Component {
  static propTypes = {
    onPublish: PropTypes.func.isRequired,
    operatingRemotely: PropTypes.bool,
    campaignId: PropTypes.string,
    shareUrl: PropTypes.string.isRequired,
    poolUrl: PropTypes.string.isRequired,
    displayUrl: PropTypes.string.isRequired,
    creationError: PropTypes.object,
  }

  campaignCreated = ({ campaignId }) => {
    return campaignId !== NEW_CAMPAIGN_ID
  }

  componentDidMount() {
    const { operatingRemotely, creationError } = this.props

    // Checking if the campaign has already been created so that we don't create it twice.
    // This can happen when going back from the share page to here.
    if (
      !operatingRemotely &&
      !creationError &&
      !this.campaignCreated(this.props)
    ) {
      this.props.onPublish()
    }
  }

  UNSAFE_componentWillReceiveProps = newProps => {
    if (this.campaignCreated(newProps) && !this.campaignCreated(this.props)) {
      sendEnsightenEvent('MoneyPoolFin')
    }
  }

  render() {
    let Component
    const { creationError } = this.props
    if (creationError) {
      if (creationError.error === UNDER_REVIEW_ERROR) {
        Component = (
          <StandardError
            key="review_error"
            iconType="error"
            title={i18n('review_error_title')}
            subtitle={i18n('review_error_subtitle')}
            backButton={true}
          />
        )
      } else {
        Component = (
          <StandardError
            key="error"
            iconType="warning"
            title={i18n('error_title')}
            subtitle={i18n('error_subtitle')}
            onTryAgain={this.props.onPublish}
          />
        )
      }
    } else if (this.campaignCreated(this.props)) {
      Component = (
        <div key="success">
          <span
            className="icon icon-large icon-circled-checkmark-large"
            styleName="create-indicator"
          />
          <div styleName="title">{i18n('live')}</div>
          <p styleName="description">{i18n('live_description')}</p>
          <Link
            to={this.props.shareUrl}
            className="vx_btn vx_btn-block"
            styleName="share-button"
            data-pa-click="share"
            data-nemo="share-pool"
          >
            {i18n('share_pool')}
          </Link>
          <a
            data-pa-click="goToPool"
            href={this.props.poolUrl}
            className="vx_btn vx_btn-block vx_btn-secondary"
            styleName="done-button"
            data-nemo="go-to-pool"
          >
            {i18n('go_to_pool')}
          </a>
        </div>
      )
    } else {
      // assume operatingRemotely
      Component = (
        <div styleName="create-indicator-container" key="spinner">
          <div className="vx_spinner-large" styleName="create-indicator" />
          <div styleName="title">{i18n('creating')}</div>
        </div>
      )
    }

    return <CrossFadeTransition>{Component}</CrossFadeTransition>
  }
}

export default cssModules(PoolPublish, styles)
